// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".partner-wx-bind[data-v-093cb24d] {\n  display: flex;\n  align-items: center;\n  gap: 0.26667rem;\n  min-height: 0.85333rem;\n}\n.partner-wx-bind .wx-name[data-v-093cb24d] {\n  color: var(--el-color-primary);\n  font-weight: 500;\n}\n.partner-wx-bind .wx-empty[data-v-093cb24d] {\n  color: #909399;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
